import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

let initialState = {
  loginInfo: {},
  isLoggedin: false,
};
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateLoginInfo: (state, action) => {
      state.loginInfo = action.payload;
      state.isLoggedin = true;
    },
    removeLoginInfo(state) {
      state.loginInfo = '';
      state.isLoggedin = false;
    },
  },
});

export function useAuthStore() {
  const loginInfo = useSelector((state) => state.auth.loginInfo);
  const isLoggedin = useSelector((state) => state.auth.isLoggedin);
  const dispatch = useDispatch();
  return {
    loginInfo,
    isLoggedin,
    updateLoginInfo: (payload) => dispatch(updateLoginInfo(payload)),
    removeLoginInfo: () => dispatch(removeLoginInfo()),
  };
}

export const {
  updateLoginInfo,
  removeLoginInfo,
} = authSlice.actions;

export default authSlice.reducer;
